module.exports = __webpack_public_path__ + "img/gyp_header.86f73ae3.jpg";